

import * as actionTypes from './actionTypes';
import * as actions from './index';

export const getLaneTreeStart = () => {
    return {
        type: actionTypes.LANES_GET_PROJECT_TREE_START
    };
};

export const getLaneTreeSuccess = (children) => {
    return {
        type: actionTypes.LANES_GET_PROJECT_TREE_SUCCESS,
        children: children
    };
};

export const getLaneTreeFail = (error) => {
    return {
        type: actionTypes.LANES_GET_PROJECT_TREE_FAIL,
        error: error
    };
};

export const updateLaneObjectsSuccess = (data) => {
    return {
        type: actionTypes.LANES_UPDATE_OBJECTS_SUCCESS,
        payload: data
    }
}

export const updateLaneObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateLaneObjectsSuccess(obj));
    }
}


export const addWorkToLane = ({ laneId, workId, type }) => {
    return ((dispatch, getState) => {
        console.log("LOGS: LAMTEST laneId workIds", laneId, workId);
        if (window.flow.sdkTvAdmAddWerkToLane) {
            window.flow.sdkTvAdmAddWerkToLane(laneId, workId)
                .then(res => {
                    console.log("LAMTEST res", res);
                    dispatch(actions.getLaneTree());
                })
                .catch(error => {
                    console.log("LAMTEST error", error);
                });
        }

    })
}

//LANE TREE
export const getLaneTree = () => {
    return dispatch => {
        dispatch({ type: actionTypes.LANES_SET_LOADING, payload: { loading: true } });
        dispatch(getLaneTreeStart());
        //window.flow.getDistprojectsForDist('sdk_tvlane').then(res => {
        window.flow.distprojectGetFullTree('sdk_tvlane').then(res => {
            console.log("LOGS: LAMTEST: getLaneTree res", res);
            // dispatch(getLaneTreeSuccess(res.objects.elements));
            dispatch(getLaneTreeSuccess(res.children));
            dispatch({ type: actionTypes.LANES_SET_LOADING, payload: { loading: false } });
        }).catch(res => {
            dispatch(getLaneTreeFail(res.message));
            dispatch(actions.applicationError(res.message));
            dispatch({ type: actionTypes.LANES_SET_LOADING, payload: { loading: false } });
        });
    };
};

export const saveNewLane = (data) => {
    console.log("LOGS: LAMTEST saveNewLane", data);
    return (dispatch => {
        window.flow.newDistproject("sdk_tvlane", 0, { 'title': data })
            .then(res => {
                console.log("LAMTEST saveNewLane RES", res);
                dispatch(getLaneTree());
            })
            .catch(err => console.log("LAMTEST saveNewLane err", JSON.stringify(err)))
    })
}